import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import {
	IPropsGetCalculateSubscription,
	IResponseGetCalculateSubscription,
} from "./types"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"
import { calculateSubscriptionURL } from "../../../utils/constants"
async function getCalculateSubscription(
	{ ...rest }: IPropsGetCalculateSubscription,
	apiPrivate: AxiosInstance
) {
	try {
		const response: AxiosResponse<IResponseGetCalculateSubscription> =
			await apiPrivate.get(`${calculateSubscriptionURL}`, {
				params: rest,
			})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetCalculateSubscription(
	data: IPropsGetCalculateSubscription,
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetCalculateSubscription,
					unknown,
					IResponseGetCalculateSubscription
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [APIS_KEYS.CALCULATESUBSCRIPTION, ...Object.values(data)],
		queryFn: () => getCalculateSubscription(data, apiPrivate),
		...options,
	})
}
